export const SELLER_ENDPOINTS = {
  createSubscription: "/people/ajax/create-subscription",
  submitDesign: "/ajax/submit-a-design",
};
